import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../Common/FormElements/Button/Button";
import { formatCurrency } from "../../Utils";
import { useDispatch, useSelector } from "react-redux";
import { updateAvoir } from "../../REDUX/actions/avoir";
import { useNavigate } from "react-router-dom";

const AvoirSummary = ({ isParticulier, id, data }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation("common");
  const navigate = useNavigate();
  const { currentAvoirsLoading } = useSelector((state) => state.avoirReducer);
  const totalHT =
    (data?.total?.reduce(
      (acc, item) => acc + (!isNaN(item.totalHT) ? Number(item.totalHT) : 0),
      0
    ) || 0) + (!isNaN(data?.delivery) ? Number(data?.delivery) : 0);
  const summary = [
    {
      label: "Total HT",
      value: formatCurrency(totalHT),
      hidden: isParticulier,
    },

    {
      label: "TVA",
      value: formatCurrency(data?.tva ? totalHT * 0.2 : 0),
      hidden: isParticulier || !data?.tva,
    },
    {
      label: "Total TTC",
      value: formatCurrency(
        data?.tva && !isParticulier ? totalHT * 1.2 : totalHT
      ),
      hidden: !data?.tva && !isParticulier,
    },
  ];

  return (
    <div className="f14 bold text-dark">
      {!totalHT && !data?.delivery ? (
        <span className="py-3 f14 text-lightBlack">
          {t("No element added")}
        </span>
      ) : (
        <div className="br10 p-2 d-flex flex-column w100">
          {summary.map(
            ({ label, value, hidden }) =>
              !hidden && (
                <div className="d-flex flex-grow-1 justify-content-between">
                  <span className="f12 bold">{label}</span>
                  <span className="f12 bold">{value}</span>
                </div>
              )
          )}
        </div>
      )}
      <Button
        className="mt-4 w-100"
        disabled={!totalHT && !data?.delivery}
        onClick={() =>
          dispatch(
            updateAvoir(id, data, isParticulier, t, () => {
              navigate("/commandes", {
                state: {
                  view: "Credits",
                },
              });
            })
          )
        }
        loading={currentAvoirsLoading}
      >
        {t("Validate")}
      </Button>
    </div>
  );
};

export default AvoirSummary;
